/**
 * GuidedViewWrapper
 * 
 * Wrapper component that provides the user's role to GuidedViewProvider
 * for role-aware step filtering.
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { GuidedViewProvider } from '../../contexts/GuidedViewContext';

export const GuidedViewWrapper = ({ children }) => {
  const { user } = useAuth();
  const userRole = user?.role || 'client_admin';
  
  return (
    <GuidedViewProvider userRole={userRole}>
      {children}
    </GuidedViewProvider>
  );
};

export default GuidedViewWrapper;
